const _404_dp = (externalBaseUrl: string) => ({
	structure: {
		type: 'Page',
		styleId: '_404_dp_style',
		id: '_404_dp',
		components: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqkrar1',
				dataQuery: '#dataItem-iuqkrars',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqkrarv',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw19',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqksom1',
				dataQuery: '#dataItem-iuqksoml',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqksoml1',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw14',
			},
			{
				type: 'Component',
				styleId: 'style-ivs5pjao',
				id: 'comp-iuqkv7ht',
				dataQuery: '#dataItem-iuqkv7ij',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzkwpfw8',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw9',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-iuqlqwdz',
				dataQuery: '#dataItem-iuqlqwf7',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqlqwfc',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw4',
			},
		],
		mobileComponents: [
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqkrar1',
				dataQuery: '#dataItem-iuqkrars',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzkwpfw18',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw19',
			},
			{
				type: 'Component',
				styleId: 'txtNew',
				id: 'comp-iuqksom1',
				dataQuery: '#dataItem-iuqksoml',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-lzzkwpfw13',
				componentType: 'wysiwyg.viewer.components.WRichText',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw14',
			},
			{
				type: 'Component',
				styleId: 'style-ivs5pjao',
				id: 'comp-iuqkv7ht',
				dataQuery: '#dataItem-iuqkv7ij',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'mobile_propItem-lzzkwpfw8',
				componentType: 'wysiwyg.viewer.components.SiteButton',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw9',
			},
			{
				type: 'Component',
				styleId: 'wp2',
				id: 'comp-iuqlqwdz',
				dataQuery: '#dataItem-iuqlqwf7',
				layout: {
					x: 0,
					y: 0,
					height: 0,
					width: 0,
				},
				propertyQuery: 'propItem-iuqlqwfc',
				componentType: 'wysiwyg.viewer.components.WPhoto',
				parent: '_404_dp',
				layoutQuery: '#layout-lzzkwpfw4',
			},
		],
		dataQuery: '#_404_dp',
		skin: 'wysiwyg.viewer.skins.page.TransparentPageSkin',
		layout: {
			x: 0,
			y: 0,
			height: 0,
			width: 0,
		},
		componentType: 'mobile.core.components.Page',
		layoutQuery: '#layout-lzzkwpfw',
	},
	data: {
		document_data: {
			_404_dp: {
				type: 'Page',
				id: '_404_dp',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				title: '404',
				hideTitle: true,
				icon: '',
				descriptionSEO: '',
				metaKeywordsSEO: '',
				pageTitleSEO: '',
				pageUriSEO: '404',
				hidePage: false,
				underConstruction: false,
				tpaApplicationId: 0,
				pageSecurity: {
					requireLogin: false,
				},
				isPopup: false,
				indexable: true,
				isLandingPage: true,
				pageBackgrounds: {
					desktop: {
						custom: true,
						ref: '#customBgImg3vn',
						isPreset: true,
					},
					mobile: {
						custom: true,
						ref: '#customBgImg24ta',
						isPreset: true,
					},
				},
				translationData: {
					uriSEOTranslated: false,
				},
				ignoreBottomBottomAnchors: true,
			},
			customBgImg24ta: {
				type: 'BackgroundMedia',
				id: 'customBgImg24ta',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			customBgImg3vn: {
				type: 'BackgroundMedia',
				id: 'customBgImg3vn',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				color: '#FFFFFF',
				alignType: 'top',
				fittingType: 'fill',
				scrollType: 'fixed',
			},
			'dataItem-iuqkrars': {
				type: 'StyledText',
				id: 'dataItem-iuqkrars',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<h4 class="font_4" style="font-size:66px"><span style="color:#3EB8EA"><span style="font-size:66px"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif">There&rsquo;s Nothing Here...</span></span></span></h4>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-iuqksoml': {
				type: 'StyledText',
				id: 'dataItem-iuqksoml',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				text:
					'<p class="font_7" style="font-size:22px; line-height:1.7em"><span style="color:#184A56"><span style="font-family:helvetica-w01-light,helvetica-w02-light,sans-serif"><span style="font-size:22px">We can&rsquo;t find the page you&rsquo;re looking for.<br />\nCheck the URL, or head back home.</span></span></span></p>\n',
				stylesMapId: 'CK_EDITOR_PARAGRAPH_STYLES',
				linkList: [],
			},
			'dataItem-iuqkv7ij': {
				type: 'LinkableButton',
				id: 'dataItem-iuqkv7ij',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				label: 'Go Home',
				link: '#dataItem-iwis0lzk',
			},
			'dataItem-iuqlqwf7': {
				type: 'Image',
				id: 'dataItem-iuqlqwf7',
				metaData: {
					isPreset: false,
					schemaVersion: '2.0',
					isHidden: false,
				},
				title: '404-icon_2.png',
				uri: '035244_516142e5fd21466aaf92b39e0883e66f~mv2.png',
				description: '',
				width: 400,
				height: 282,
				alt: '',
				crop: {
					x: 26,
					y: 16,
					width: 346,
					height: 239,
				},
			},
			'dataItem-iwis0lzk': {
				type: 'ExternalLink',
				id: 'dataItem-iwis0lzk',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				url: externalBaseUrl,
				target: '_self',
			},
		},
		design_data: {},
		behaviors_data: {},
		connections_data: {},
		theme_data: {
			'style-ivs5pjao': {
				type: 'TopLevelStyle',
				id: 'style-ivs5pjao',
				metaData: {
					isPreset: false,
					schemaVersion: '1.0',
					isHidden: false,
				},
				style: {
					properties: {
						'alpha-bg': '0',
						'alpha-bgh': '1',
						'alpha-brd': '1',
						'alpha-brdh': '0',
						'alpha-txt': '1',
						'alpha-txth': '1',
						bg: '#3EB8EA',
						bgh: '#4EB7F5',
						'boxShadowToggleOn-shd': 'false',
						brd: '#4EB7F5',
						brdh: '#3D9BE9',
						brw: '2',
						fnt: 'normal normal normal 22px/1.4em helvetica-w01-light',
						rd: '40px',
						shd: '0px 1px 4px 0px rgba(0,0,0,0.6)',
						txt: '#4EB7F5',
						txth: '#FFFFF1',
					},
					propertiesSource: {
						'alpha-bg': 'value',
						'alpha-brdh': 'value',
						bg: 'value',
						bgh: 'value',
						brd: 'value',
						brdh: 'value',
						brw: 'value',
						fnt: 'value',
						rd: 'value',
						shd: 'value',
						txt: 'value',
						txth: 'value',
					},
					groups: {},
				},
				componentClassName: 'wysiwyg.viewer.components.SiteButton',
				pageId: '',
				compId: '',
				styleType: 'custom',
				skin: 'wysiwyg.viewer.skins.button.BasicButton',
			},
		},
		component_properties: {
			'mobile_propItem-iuqkrarv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
			},
			'mobile_propItem-iuqksoml1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
			},
			'propItem-iuqkrarv': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-iuqksoml1': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				brightness: 1,
				packed: true,
			},
			'propItem-iuqkv7ik': {
				type: 'ButtonProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				align: 'center',
				margin: 0,
			},
			'propItem-iuqlqwfc': {
				type: 'WPhotoProperties',
				metaData: {
					schemaVersion: '1.0',
				},
				displayMode: 'fill',
				onClickBehavior: 'goToLink',
				effectName: 'none',
			},
			'propItem-lzzkwpfw8': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				id: 'propItem-lzzkwpfw8',
			},
			'mobile_propItem-lzzkwpfw8': {
				type: 'ButtonProperties',
				align: 'center',
				margin: 0,
				metaData: {
					schemaVersion: '1.0',
				},
				fontScale: 0.863837598531476,
				id: 'mobile_propItem-lzzkwpfw8',
			},
			'propItem-lzzkwpfw13': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				fontScale: 0.6948499742213815,
				id: 'propItem-lzzkwpfw13',
			},
			'propItem-lzzkwpfw18': {
				type: 'WRichTextProperties',
				metaData: {
					schemaVersion: '1.0',
					autoGenerated: false,
				},
				brightness: 1,
				packed: true,
				overrideAlignment: 'center',
				fontScale: 0.8084127123905273,
				id: 'propItem-lzzkwpfw18',
			},
		},
		variants_data: {},
		layout_data: {
			'layout-lzzkwpfw': {
				id: 'layout-lzzkwpfw',
				type: 'RefArray',
				values: ['#layout-lzzkwpfw1', '#layout-lzzkwpfw3'],
			},
			'layout-lzzkwpfw1': {
				id: 'layout-lzzkwpfw1',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw2': {
				id: 'layout-lzzkwpfw2',
				componentLayout: {
					type: 'ClassicComponentLayout',
					height: {
						type: 'auto',
					},
					width: {
						type: 'auto',
					},
				},
				containerLayout: {
					type: 'MeshContainerLayout',
					meshData: {
						contentHeight: 'auto',
					},
					contentArea: {
						width: {
							type: 'SystemVariable',
							value: 'siteWidth',
						},
						alignment: 'center',
					},
				},
				itemLayout: {},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw3': {
				id: 'layout-lzzkwpfw3',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkwpfw2',
				from: '#_404_dp',
			},
			'layout-lzzkwpfw4': {
				id: 'layout-lzzkwpfw4',
				type: 'RefArray',
				values: ['#layout-lzzkwpfw5', '#layout-lzzkwpfw7'],
			},
			'layout-lzzkwpfw5': {
				id: 'layout-lzzkwpfw5',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 339,
					},
					height: {
						type: 'px',
						value: 235,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 174,
						y: 100,
						width: 339,
						height: 235,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw6': {
				id: 'layout-lzzkwpfw6',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 272,
					},
					height: {
						type: 'px',
						value: 196,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 24,
						y: -23,
						width: 272,
						height: 196,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw7': {
				id: 'layout-lzzkwpfw7',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkwpfw6',
				from: '#comp-iuqlqwdz',
			},
			'layout-lzzkwpfw9': {
				id: 'layout-lzzkwpfw9',
				type: 'RefArray',
				values: ['#layout-lzzkwpfw10', '#layout-lzzkwpfw12'],
			},
			'layout-lzzkwpfw10': {
				id: 'layout-lzzkwpfw10',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 198,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 599,
						width: 198,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw11': {
				id: 'layout-lzzkwpfw11',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 204,
					},
					height: {
						type: 'px',
						value: 56,
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 53,
						y: 372,
						width: 204,
						height: 56,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw12': {
				id: 'layout-lzzkwpfw12',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkwpfw11',
				from: '#comp-iuqkv7ht',
			},
			'layout-lzzkwpfw14': {
				id: 'layout-lzzkwpfw14',
				type: 'RefArray',
				values: ['#layout-lzzkwpfw15', '#layout-lzzkwpfw17'],
			},
			'layout-lzzkwpfw15': {
				id: 'layout-lzzkwpfw15',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 475,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 207,
						y: 482,
						width: 475,
						height: 76,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw16': {
				id: 'layout-lzzkwpfw16',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 277,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 21,
						y: 265,
						width: 277,
						height: 78,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw17': {
				id: 'layout-lzzkwpfw17',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkwpfw16',
				from: '#comp-iuqksom1',
			},
			'layout-lzzkwpfw19': {
				id: 'layout-lzzkwpfw19',
				type: 'RefArray',
				values: ['#layout-lzzkwpfw20', '#layout-lzzkwpfw22'],
			},
			'layout-lzzkwpfw20': {
				id: 'layout-lzzkwpfw20',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 752,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 203,
						y: 379,
						width: 752,
						height: 81,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw21': {
				id: 'layout-lzzkwpfw21',
				componentLayout: {
					type: 'ClassicComponentLayout',
					width: {
						type: 'px',
						value: 320,
					},
					height: {
						type: 'auto',
					},
				},
				containerLayout: {},
				itemLayout: {
					type: 'MeshItemLayout',
					meshData: {
						x: 0,
						y: 208,
						width: 320,
						height: 39,
					},
					justifySelf: 'content',
				},
				type: 'SingleLayoutData',
			},
			'layout-lzzkwpfw22': {
				id: 'layout-lzzkwpfw22',
				type: 'VariantRelation',
				variants: ['#MOBILE-VARIANT'],
				to: '#layout-lzzkwpfw21',
				from: '#comp-iuqkrar1',
			},
		},
		transformations_data: {},
	},
	title: '404',
	pageUriSEO: '404',
})

export default _404_dp
